import React from 'react';
import { usePolicyContext } from '../usePolicyContext';
import { NavigationItem } from 'ui-toolkit';
import { ePolicyContextActionType } from '../actions/ePolicyContextActionType';
import { eSingleFields } from '../state/eSingleFields';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export interface IModalTriggerButtonProps {
  fieldName: eSingleFields;
}

export const ModalTriggerButton: FCWithChildren<IModalTriggerButtonProps> = ({ children, fieldName }) => {
  const [, dispatch] = usePolicyContext();
  return (
    <NavigationItem
      text={``}
      isInline
      onClick={() => dispatch({ type: ePolicyContextActionType.OpenEditSingleFieldAction, payload: fieldName })}
    >
      {children}
    </NavigationItem>
  );
};
